import { COMMON_PROPERTIES } from './constants';
import { TJsonQueryKeys, TJsonQueryOptionalKeys } from '../../../../JsonQuery';
import { IJsonQuery } from '../../../../api-models/common/json_query';

export function getUncommonProperties(jsonQuery: IJsonQuery): TJsonQueryOptionalKeys[] {
  return (Object.keys(jsonQuery) as TJsonQueryKeys[]).filter(
    (property): property is TJsonQueryOptionalKeys => !COMMON_PROPERTIES.includes(property),
  );
}
